export default "__VITE_ASSET__CcCCqh$r__"